import { Controller, FormProvider } from 'react-hook-form';
import { PersonTypeEnum } from '@clickersphere/core/enums/PersonTypeEnum';
import { Button } from '../../Button';
import ContractAddressFields from '../../ContractAddressFields';
import DocumentInput from '../../DocumentInput';
import { Input } from '../../Input';
import { RadioGroup, RadioGroupItem } from '../../Radio';
import { useContractorModalController } from './useContractorModalController';

export default function ContractorModal() {
  const {
    t,
    form,
    register,
    control,
    errors,
    personType,
    isLegalEntity,
    isFetching,
    handlePersonTypeChange,
    handleSubmit,
    handleCloseModal,
  } = useContractorModalController();

  return (
    <FormProvider {...form}>
      <form
        className="my-4 flex max-h-[65vh] w-full flex-col gap-4 overflow-y-auto px-1"
        onSubmit={handleSubmit}
        noValidate
      >
        <RadioGroup
          value={personType}
          onChange={handlePersonTypeChange}
          name="personType"
          disabled={isFetching}
          aria-label={t('contract.contractor.personType.label')}
          className="flex-row gap-3"
        >
          <RadioGroupItem
            value={PersonTypeEnum.PF}
            label={t('contract.contractor.personType.PF')}
            className="flex-1"
          />
          <RadioGroupItem
            value={PersonTypeEnum.PJ}
            label={t('contract.contractor.personType.PJ')}
            className="flex-1"
          />
        </RadioGroup>

        <Input
          type="text"
          placeholder={t('contract.contractor.fields.name')}
          {...register('name')}
          error={errors.name?.message}
          autoComplete="name"
          disabled={isFetching}
        />

        <Controller
          control={control}
          name="documentNumber"
          render={({ field: { name, value, onChange } }) => (
            <DocumentInput
              name={name}
              value={value}
              onChange={onChange}
              placeholder={
                isLegalEntity
                  ? t('contract.contractor.fields.cnpj')
                  : t('contract.contractor.fields.cpf')
              }
              error={errors.documentNumber?.message}
              disabled={isFetching}
            />
          )}
        />

        {isLegalEntity && (
          <>
            <Input
              type="text"
              placeholder={t(
                'contract.contractor.fields.legalRepresentativeName',
              )}
              {...register('legalRepresentativeName')}
              error={errors.legalRepresentativeName?.message}
              disabled={isFetching}
            />
            <Controller
              control={control}
              name="legalRepresentativeDocument"
              render={({ field: { name, value, onChange } }) => (
                <DocumentInput
                  name={name}
                  value={value}
                  onChange={onChange}
                  placeholder={t(
                    'contract.contractor.fields.legalRepresentativeDocument',
                  )}
                  error={errors.legalRepresentativeDocument?.message}
                  disabled={isFetching}
                />
              )}
            />
          </>
        )}

        <Input
          type="email"
          placeholder={t('contract.contractor.fields.email')}
          {...register('email')}
          error={errors.email?.message}
          autoComplete="email"
          disabled={isFetching}
        />
        <Input
          type="tel"
          placeholder={t('contract.contractor.fields.phone')}
          {...register('phone')}
          error={errors.phone?.message}
          autoComplete="tel"
          disabled={isFetching}
        />
        <Input
          type="text"
          placeholder={t('contract.contractor.fields.instagram')}
          {...register('instagram')}
          error={errors.instagram?.message}
          disabled={isFetching}
        />

        <ContractAddressFields disabled={isFetching} />

        <section className="mt-2 flex w-full flex-col gap-3 sm:flex-row sm:gap-4">
          <Button
            className="w-full sm:w-50"
            labelPath="contract.contractor.modal.cancel"
            color="ghost"
            disabled={isFetching}
            onClick={handleCloseModal}
          />
          <Button
            className="w-full"
            labelPath="contract.contractor.modal.save"
            type="submit"
            disabled={isFetching}
            isLoading={isFetching}
          />
        </section>
      </form>
    </FormProvider>
  );
}
